/*-----------------------------------------------------------------
- Home
-----------------------------------------------------------------*/
export default {
    title               : 'خانه',
    products_category   : 'دسته‌بندی محصولات',
    discounted_products : 'تخفیف خورده‌ها',
    bestsellers_products: 'پرفروش‌ترین محصولات',
    all_discounts       : 'همه‌ی تخفیفات',
    all_products        : 'همه‌ی محصولات',
    see_more            : 'مشاهده بیشتر',
    feature_title       : 'چرا از خشکبار بانمک خرید کنیم؟',
    blog                : 'تازه‌ترین مطالب',
    all_posts           : 'همه‌ی مطالب',
};
